export default __webpack_public_path__ + "static/media/img-0749-romania-half-face.b8841da9.png";